var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 64,
    cy: 64,
    r: 63,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.563 100.032c33.076 0 51.162-27.4 51.162-51.16 0-.779-.017-1.554-.052-2.325a36.582 36.582 0 0 0 8.97-9.312 35.87 35.87 0 0 1-10.326 2.831 18.047 18.047 0 0 0 7.908-9.946 36.057 36.057 0 0 1-11.42 4.365 17.96 17.96 0 0 0-13.125-5.68c-9.93 0-17.982 8.052-17.982 17.978 0 1.412.158 2.783.467 4.1-14.945-.752-28.197-7.908-37.065-18.788a17.941 17.941 0 0 0-2.435 9.038 17.967 17.967 0 0 0 8.002 14.968 17.846 17.846 0 0 1-8.144-2.249c-.002.075-.002.15-.002.23 0 8.707 6.198 15.98 14.426 17.625a18.004 18.004 0 0 1-8.122.31c2.29 7.145 8.928 12.343 16.798 12.488a36.07 36.07 0 0 1-22.333 7.697c-1.45 0-2.882-.082-4.29-.248a50.89 50.89 0 0 0 27.563 8.078"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.d6ec9525c69a91a6eb36d785f4dc2dd6.svg";
export { ForwardRef as ReactComponent };